import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { ReactNode } from 'react';
import { getBusinessProcessCatalogsDropdown } from '@martech-solution/utils/apis';

interface Props {
  value?: number;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: number) => void;
  placeholder?: ReactNode;
  popupMatchSelectWidth?: number;
}

export default function BusinessProcessCatalogSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  popupMatchSelectWidth
}: Props) {
  const businessProcessCatalogsDropdownQuery = useQuery({
    queryKey: ['businessProcessCatalogsDropdown'],
    queryFn: () => getBusinessProcessCatalogsDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      popupMatchSelectWidth={popupMatchSelectWidth ?? 400}
      allowClear={allowClear}
      value={businessProcessCatalogsDropdownQuery.isFetching ? undefined : value}
      style={style}
      placeholder={placeholder}
      onChange={onChange}
      optionLabelProp='selectedShow'
      options={businessProcessCatalogsDropdownQuery.data?.data.map((data) => ({
        value: data.id,
        label: `${data.code} - ${data.name}`,
        selectedShow: `${data.name}`
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={businessProcessCatalogsDropdownQuery.isFetching}
    />
  );
}
